import styled from 'styled-components'
import { colors } from 'client/styles'

export const TextAreaInput = styled.textarea`
  color: ${colors.grey1};
  min-height: 175px;
  max-width: 100%;
  width: 100%;
  resize: vertical;
  padding-block: 12px;
  padding-inline: 14px;
  background: ${colors.white};
  border: 2px solid ${colors.grey4};
  border-radius: 8px;
  cursor: pointer;
  font-family: ${props => props.theme.fonts.families.primary};
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;

  outline: none;
  color: ${colors.grey1};

  :hover {
    border: 2px solid ${colors.grey1};
  }

  :active,
  :focus {
    border: 2px solid ${colors.grey2};
  }

  ::placeholder {
    color: ${colors.grey2};
    font-weight: 500;
  }
`
